module.exports = __webpack_public_path__ + "img/tsinghua_anniversary-20160423-1-1024x768.d9511676.jpg";